import { render, staticRenderFns } from "./Threads.vue?vue&type=template&id=b95bf5fc&scoped=true"
import script from "./Threads.vue?vue&type=script&lang=ts"
export * from "./Threads.vue?vue&type=script&lang=ts"
import style0 from "./Threads.vue?vue&type=style&index=0&id=b95bf5fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95bf5fc",
  null
  
)

export default component.exports